import { TOKEN } from "./config.js";

export const getData = async (url) => {
    const response = await fetch(url, {
        headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })

    return await response.json();
}

export const sendData = async (url, data) => {
    const response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
            'Authorization': `Bearer ${TOKEN}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })

    return await response.json();
}

export const sendImage = async (url, data) => {
    const response = await fetch(url, {
        method: 'POST',
        body: data,
        headers: {
            'Authorization': `Bearer ${TOKEN}`,
            'Accept': 'application/json',
        }
    })
    return await response.json();
}

export const getYouTubeData = async (url) => {
    const response = await fetch(url)
    return await response.json();
}